/**
 * 默认发色：不变, 本地化键key
 */
export const HAIR_COLOR_NO_CHANGE = 'No change';
export const HAIR_COLOR_NO_CHANGE_KEY = 'no-change';

/**
 * 默认发型：不变, 本地化键key
 */
export const HAIR_STYLE_NO_CHANGE = 'No change';
export const HAIR_STYLE_NO_CHANGE_KEY = 'no-change';

/**
 * 默认性别：无
 */
export const NONE_GENDER = 'none';
export const HAIRSTYLE_GENDER_MALE = 'male';
export const HAIRSTYLE_GENDER_FEMALE = 'female';

export const HAIRSTYLE_TAB_LIST = [{ text: 'female' }, { text: 'male' }, { text: 'color' }];

/**
 * 发型列表（按性别和分类）
 */
export const HAIRSTYLE_LIST = {
    female: [
        {
            categoryName: 'basic',
            hairstyles: [
                {
                    key: 'straight',
                    value: 'Straight',
                    filename: 'female_straight_straight.png',
                },
                {
                    key: 'curly',
                    value: 'Curly',
                    filename: 'female_curly_curly.png',
                },
                {
                    key: 'tousled',
                    value: 'Tousled',
                    filename: 'female_basic_tousled.png',
                },
                {
                    key: 'wavy',
                    value: 'Wavy',
                    filename: 'female_curly_wavy.png',
                },
                {
                    key: 'side-swept-bangs',
                    value: 'Side-Swept Bangs',
                    filename: 'female_bangs-part_side-swept-bangs.png',
                },
                {
                    key: 'center-parted',
                    value: 'Center-Parted',
                    filename: 'female_bangs-part_center-parted.png',
                },
                {
                    key: 'slicked-back',
                    value: 'Slicked Back',
                    filename: 'female_bangs-part_slicked-back.png',
                },
            ],
        },
        {
            categoryName: 'ponytail',
            hairstyles: [
                {
                    key: 'high-ponytail',
                    value: 'High Ponytail',
                    filename: 'female_ponytail_high-ponytail.png',
                },
                {
                    key: 'low-ponytail',
                    value: 'Low Ponytail',
                    filename: 'female_ponytail_low-ponytail.png',
                },
                {
                    key: 'braided-ponytail',
                    value: 'Braided Ponytail',
                    filename: 'female_ponytail_high-braided-ponytail.png',
                },
                {
                    key: 'pigtails',
                    value: 'Pigtails',
                    filename: 'female_ponytail_pigtails.png',
                },
            ],
        },
        {
            categoryName: 'short',
            hairstyles: [
                {
                    key: 'bob',
                    value: 'Bob',
                    filename: 'female_short_bob.png',
                },
                {
                    key: 'faux-hawk',
                    value: 'Faux Hawk',
                    filename: 'female_short_faux-hawk.png',
                },
            ],
        },
        {
            categoryName: 'braid',
            hairstyles: [
                {
                    key: 'double-dutch-braids',
                    value: 'Double Dutch Braids',
                    filename: 'female_braid_double-dutch-braids.png',
                },
                {
                    key: 'fishtail-braid',
                    value: 'Fishtail Braid',
                    filename: 'female_braid_fishtail-braid.png',
                },
                {
                    key: 'braided-crown',
                    value: 'Braided Crown',
                    filename: 'female_braid_braided-crown.png',
                },
                {
                    key: 'twist-out',
                    value: 'Twist Out',
                    filename: 'female_afro_twist-out.png',
                },
                {
                    key: 'dreadlocks',
                    value: 'Dreadlocks',
                    filename: 'female_afro_dreadlocks.png',
                },
            ],
        },
        {
            categoryName: 'updos-buns',
            hairstyles: [
                {
                    key: 'messy-bun',
                    value: 'Messy Bun',
                    filename: 'female_top-bun_messy-bun.png',
                },
                {
                    key: 'space-buns',
                    value: 'Space Buns',
                    filename: 'female_top-bun_space-buns.png',
                },
                {
                    key: 'beehive',
                    value: 'Beehive',
                    filename: 'female_bun_messy-beehive.png',
                },
                {
                    key: 'bouffant',
                    value: 'Bouffant',
                    filename: 'female_bun_bouffant.png',
                },
                {
                    key: 'french-roll',
                    value: 'French Roll',
                    filename: 'female_curly_french-roll.png',
                },
                {
                    key: 'pin-curls',
                    value: 'Pin Curls',
                    filename: 'female_curly_pin-curls.png',
                },
            ],
        },
        {
            categoryName: 'decorative',
            hairstyles: [
                {
                    key: 'hair-bow',
                    value: 'Hair Bow',
                    filename: 'female_decorative_hair-bow.png',
                },
                {
                    key: 'messy-bun-with-a-headband',
                    value: 'Messy Bun with a Headband',
                    filename: 'female_top-bun_messy-bun-with-a-headband.png',
                },
            ],
        },
    ],
    male: [
        {
            categoryName: 'basic',
            hairstyles: [
                {
                    key: 'curly',
                    value: 'Curly',
                    filename: 'male_basic_curly.png',
                },
                {
                    key: 'crew-cut',
                    value: 'Crew Cut',
                    filename: 'male_short_crew-cut.png',
                },
                {
                    key: 'mohawk',
                    value: 'Mohawk',
                    filename: 'male_short_mohawk.png',
                },
                {
                    key: 'faux-hawk',
                    value: 'Faux Hawk',
                    filename: 'male_short_faux-hawk.png',
                },
                {
                    key: 'side-parted',
                    value: 'Side-Parted',
                    filename: 'male_bangs_side-parted.png',
                },
                {
                    key: 'slicked-back',
                    value: 'Slicked Back',
                    filename: 'male_short_undercut_slicked-back.png',
                },
            ],
        },
        {
            categoryName: 'ponytails-buns',
            hairstyles: [
                {
                    key: 'low-ponytail',
                    value: 'Low Ponytail',
                    filename: 'male_ponytail_low-ponytail.png',
                },
                {
                    key: 'topknot',
                    value: 'Top Knot',
                    filename: 'male_bun_topknot.png',
                },
                {
                    key: 'space-buns',
                    value: 'Space Buns',
                    filename: 'male_bun_space-buns.png',
                },
            ],
        },
        {
            categoryName: 'braid',
            hairstyles: [
                {
                    key: 'fishtail-braid',
                    value: 'Fishtail Braid',
                    filename: 'male_braids_fishtail-braid.png',
                },
                {
                    key: 'bohemian-braids',
                    value: 'Bohemian Braids',
                    filename: 'male_braids_bohemian-braids.png',
                },
                {
                    key: 'bantu-knots',
                    value: 'Bantu Knots',
                    filename: 'male_afro_bantuknots.png',
                },
                {
                    key: 'dreadlocks',
                    value: 'Dreadlocks',
                    filename: 'male_afro_dreadlocks.png',
                },
            ],
        },
    ],
};

/**
 * 发色列表
 */
export const HAIR_COLOR_LIST = [
    { key: 'ash-blonde', value: 'Ash Blonde', filename: 'ash-blonde.png' },
    { key: 'ash-brown', value: 'Ash Brown', filename: 'ash-brown.png' },
    { key: 'auburn', value: 'Auburn', filename: 'auburn.png' },
    { key: 'black', value: 'Black', filename: 'black.png' },
    { key: 'blonde', value: 'Blonde', filename: 'blonde.png' },
    { key: 'blue', value: 'Blue', filename: 'blue.png' },
    { key: 'blue-black', value: 'Blue-Black', filename: 'blue-black.png' },
    { key: 'brunette', value: 'Brunette', filename: 'brunette.png' },
    { key: 'burgundy', value: 'Burgundy', filename: 'burgundy.png' },
    { key: 'caramel', value: 'Caramel', filename: 'caramel.png' },
    { key: 'chestnut', value: 'Chestnut', filename: 'chestnut.png' },
    { key: 'copper', value: 'Copper', filename: 'copper.png' },
    { key: 'dark-brown', value: 'Dark Brown', filename: 'dark-brown.png' },
    { key: 'golden-blonde', value: 'Golden Blonde', filename: 'golden-blonde.png' },
    { key: 'green', value: 'Green', filename: 'green.png' },
    { key: 'honey-blonde', value: 'Honey Blonde', filename: 'honey-blonde.png' },
    { key: 'jet-black', value: 'Jet Black', filename: 'jet-black.png' },
    { key: 'light-brown', value: 'Light Brown', filename: 'light-brown.png' },
    { key: 'mahogany', value: 'Mahogany', filename: 'mahogany.png' },
    { key: 'medium-brown', value: 'Medium Brown', filename: 'medium-brown.png' },
    { key: 'pink', value: 'Pink', filename: 'pink.png' },
    { key: 'platinum-blonde', value: 'Platinum Blonde', filename: 'platinum-blonde.png' },
    { key: 'purple', value: 'Purple', filename: 'purple.png' },
    { key: 'red', value: 'Red', filename: 'red.png' },
    { key: 'rose-gold', value: 'Rose Gold', filename: 'rose-gold.png' },
    { key: 'silver', value: 'Silver', filename: 'silver.png' },
    { key: 'strawberry-blonde', value: 'Strawberry Blonde', filename: 'strawberry-blonde.png' },
    { key: 'titanium', value: 'Titanium', filename: 'titanium.png' },
    { key: 'white', value: 'White', filename: 'white.png' },
];

/**
 * 发色选项，包括 no change
 */
export const HAIR_COLOR_OPTIONS = [
    {
        key: HAIR_COLOR_NO_CHANGE_KEY,
        value: HAIR_COLOR_NO_CHANGE,
        filename: null,
    },
    ...HAIR_COLOR_LIST,
];

export const SUITABLE_PHOTOS = ['right-1.png', 'right-2.png', 'right-3.png'];

export const UNSUITABLE_PHOTOS = ['error-1.png', 'error-6.png', 'error-2.png', 'error-3.png', 'error-4.png'];

/**
 * 根据 gender、hairstyle、color 获取对应的发型和发色信息
 * @param {'male'|'female'} gender
 * @param {string} hairstyle 发型value
 * @param {string} color 发色value
 * @returns {{
 *   hairstyle: { key: string, value: string, filename: string } | null,
 *   hairColor: { key: string, value: string, filename: string | null } | null
 * }}
 */
export function getHairstyleAndColorInfo(gender, hairstyle, color) {
    let hairstyleInfo = null;
    let colorInfo = null;

    // 查找发型
    const genderList = HAIRSTYLE_LIST[gender];
    if (genderList) {
        for (const category of genderList) {
            const found = category.hairstyles.find(item => item.value === hairstyle || item.key === hairstyle);
            if (found) {
                hairstyleInfo = found;
                break;
            }
        }
    }

    // 查找发色
    if (color === HAIR_COLOR_NO_CHANGE_KEY || color === HAIR_COLOR_NO_CHANGE) {
        colorInfo = {
            key: HAIR_COLOR_NO_CHANGE_KEY,
            value: HAIR_COLOR_NO_CHANGE,
            filename: null,
        };
    } else {
        colorInfo = HAIR_COLOR_LIST.find(item => item.value === color || item.key === color) || null;
    }

    return {
        hairstyle: hairstyleInfo,
        hairColor: colorInfo,
        gender,
    };
}
